import type { WorldcupResearchFacetItem } from '~/features/worldcup-research/types'

export function teamNameToSlug(team: string) {
  return team
    .trim()
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036F]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export function resolveTeamLabelFromSlug(teamSlug: string, teams: WorldcupResearchFacetItem[]) {
  return teams.find(team => teamNameToSlug(team.value) === teamSlug)?.value ?? teamSlug
}

export function matchTeamSuggestions(input: string, teams: WorldcupResearchFacetItem[]) {
  const normalized = input.trim().toLowerCase()
  if (!normalized)
    return teams.slice(0, 12)

  return teams
    .filter(team => team.value.toLowerCase().includes(normalized) || teamNameToSlug(team.value).includes(normalized))
    .slice(0, 12)
}
